// $FlowFixMe
import React, { Component, forwardRef } from 'react';

import cx from 'classnames';
import _debounce from 'lodash.debounce';
import _memoize from 'lodash.memoize';
import memoizeOne from 'memoize-one';
import { SizeMe } from 'react-sizeme';
import { FixedSizeList, FixedSizeGrid } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import SVG from 'react-inlinesvg';
import Icon from '../../Icon';
import Filters from './Filters';
import Placeholder from './Placeholder';
import BulkActions from '../../BulkActions';
import CardItem from './Card/components/CardItem';
import CardCaption from './CardCaption';
import ListItem from './ListItem';
import EmptyDataPlaceholder from './EmptyDataPlaceholder';
import Checkbox from '../../Checkbox';
import { GRID_VIEW, LIST_VIEW } from '../constants/viewTypes';
import { LIST_CONTAINER } from '../styles/reactWindowList';
import { NUMERIC_MEDIA_SIZES } from '../../../common/styles/vars';
import { empty } from '../../../assets/images';
import Text from '../../Text';
import '../styles/_reactWindowList.scss';


















































const LOADER_INITIAL_TIMEOUT = 1500;
const LOADER_LOAD_MORE_TIMEOUT = 500;
const GRID_ITEM_WIDTH = 340;
const GRID_ITEM_HEIGHT = 290;
const GUTTER_SIZE = 20;

export default class ReactWindowList extends Component {


  handleChangeView = _memoize((view) => () => {
    const { history } = this.props;

    history.push(`#${view}`);
  });

  static defaultProps = {
    data: [],
    filters: {},
    listKey: 'id'
  };

  constructor(props) {
    super(props);

    const { data } = this.props;

    const itemStatusMap = new Map();

    data.forEach((item, i) => itemStatusMap.set(i, item));

    this.state = {
      selectedFilters: {},
      searchTerm: '',
      bothViewsAvailable: Boolean(props.renderCardItem && props.renderListItem),
      selectedItems: {},
      hasBulkActions: props.canSelectItems || Boolean(props.bulkActions),
      loading: false,
      itemStatusMap
    };

    if (props.loading) {
      this.setLoading();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { data, loading } = this.props;
    const { searchTerm, selectedFilters, loading: stateLoading } = this.state;

    if (!loading && prevProps.loading) {
      this.attemptToClearLoadingTimer();
    }

    if (!loading && prevProps.loading && stateLoading) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loading: false });
    }

    if (loading && !prevProps.loading && !stateLoading) {
      this.setLoading();
    }

    if (prevProps.data !== data) {
      const itemStatusMap = new Map();

      data.forEach((item, i) => itemStatusMap.set(i, item));
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ itemStatusMap });
    }

    if (prevProps.data !== data || prevState.searchTerm !== searchTerm ||
    prevState.selectedFilters !== selectedFilters) {
      this.hideSelectedItems();
    }
  }

  componentWillUnmount() {
    this.attemptToClearLoadingTimer();
  }

  getFilteredData = memoizeOne((data, selectedFilters, searchTerm, onFiltersChange) => {
    if (onFiltersChange) {return data;}

    const searchData = data.filter((item) => Object.values(item).some((dataField) =>
    dataField && typeof dataField === 'string' &&
    dataField.toLowerCase().includes(searchTerm.toLowerCase())
    ));

    return searchData.filter((item) => {
      const allFilters = Object.values(selectedFilters);
      const filterResults = allFilters.map(({ value }) => value instanceof Function ?
      value(item) :
      true);

      return filterResults.filter((val) => val).length === filterResults.length;
    });
  });

  setLoading = (timeout) => {
    this.attemptToClearLoadingTimer();
    this._timeout = setTimeout(this.showLoader, timeout || LOADER_INITIAL_TIMEOUT);
  };

  showLoader = () => {
    this.setState({ loading: true });
  };

  attemptToClearLoadingTimer = () => {
    if (!this._timeout) {return;}

    clearTimeout(this._timeout);

    this._timeout = null;
  };

  hideSelectedItems = () => {
    const { listKey, bulkActions, onFiltersChange } = this.props;
    const { selectedFilters, searchTerm, itemStatusMap, selectedItems } = this.state;
    const data = Array.from(itemStatusMap.values());
    const filteredData = this.getFilteredData(data, selectedFilters, searchTerm, onFiltersChange);

    if (!bulkActions) {return;}

    const newSelected = Object.entries(selectedItems).reduce((selected, [itemId, isSelected]) => {
      if (!isSelected) {return selected;}

      const dataItemExists = filteredData.some((item) => item[listKey] === itemId);

      if (!dataItemExists) {return selected;}

      return { ...selected, [itemId]: true };
    }, {});

    this.setState({ selectedItems: newSelected });
  };

  handleItemsSelected = () => {
    const { onSelectItems } = this.props;

    if (!onSelectItems) {return;}

    const { selectedItems } = this.state;

    onSelectItems(Object.values(selectedItems).filter(Boolean));
  };

  onSelectItem = (itemListIndex) => () => {
    const { selectedItems, selectedFilters, searchTerm, itemStatusMap } = this.state;
    const { listKey, onFiltersChange } = this.props;
    const selectedTotal = Object.values(selectedItems).filter(Boolean).length;
    const data = Array.from(itemStatusMap.values());

    const filteredData = this.getFilteredData(data, selectedFilters, searchTerm, onFiltersChange);

    // Select All
    if (itemListIndex === void 0 && !selectedTotal) {
      return void this.setState({
        selectedItems: filteredData.reduce((selected, dataItem) => ({
          ...selected,
          [dataItem[listKey]]: dataItem
        }), {})
      }, this.handleItemsSelected);
    }

    // Unselect all
    if (itemListIndex === void 0) {
      return void this.setState({ selectedItems: {} }, this.handleItemsSelected);
    }

    // Select one
    const item = filteredData[itemListIndex];
    const itemId = item[listKey];

    this.setState(({ selectedItems: latestItems }) => ({
      selectedItems: { ...latestItems, [itemId]: latestItems[itemId] ? void 0 : item }
    }), this.handleItemsSelected);
  };

  onSelectBulkAction = (action) => () => {
    const { selectedItems } = this.state;
    const { data, listKey } = this.props;

    action(data.filter((item) => selectedItems[item[listKey]]));
  };

  setSelectedFilters = (changedFilters) => {
    const { selectedFilters } = this.state;
    const mergedFilters = { ...selectedFilters, ...changedFilters };
    const newFilters = Object.keys(mergedFilters).reduce((reducedFilters, filterKey) => {
      const hasValue = mergedFilters[filterKey];

      if (!hasValue) {return reducedFilters;}

      return { ...reducedFilters, [filterKey]: mergedFilters[filterKey] };
    }, {});

    this.setState({ selectedFilters: newFilters }, this.callOnFiltersChangeCallback);
  };

  callOnFiltersChangeCallback = () => {
    const { onFiltersChange } = this.props;
    const { searchTerm } = this.state;

    if (!onFiltersChange) {return;}

    onFiltersChange({ filters: this.getSelectedFiltersData(), searchTerm });
  };

  getSelectedFiltersData = () => {
    const { selectedFilters } = this.state;

    return Object.keys(selectedFilters).
    reduce((filtersObj, filterName) => ({
      ...filtersObj,
      [filterName]: selectedFilters[filterName].value
    }), {});
  };

  resetFilters = () => {
    const { initialFilterState = {} } = this.props;
    this.setState({ selectedFilters: initialFilterState }, this.callOnFiltersChangeCallback);
  };

  onSearch = ({ target: { value } }) => {
    this.setState({ searchTerm: value }, this.callOnFiltersChangeCallback);
  };

  getView = (hash) => {
    const { renderCardItem, renderListItem } = this.props;

    const view = hash ? hash.substr(1, hash.length) : GRID_VIEW;

    if (view !== GRID_VIEW && view !== LIST_VIEW) {
      return renderCardItem ? GRID_VIEW : LIST_VIEW;
    }

    if (view === GRID_VIEW && !renderCardItem) {
      return LIST_VIEW;
    }

    if (view === LIST_VIEW && !renderListItem) {
      return GRID_VIEW;
    }

    return view;
  };

  loadMoreResults = async (startIndex, stopIndex) => {
    const { loadMoreResults } = this.props;
    const { itemStatusMap } = this.state;

    if (!loadMoreResults) {return Promise.resolve();}

    this.setLoading(LOADER_LOAD_MORE_TIMEOUT);

    const result = await loadMoreResults({ currentOffset: startIndex, totalResults: stopIndex });

    const { data, totalResults } = this.props;

    const items = result && result.length ? result : data;

    if (items.length !== totalResults) {
      for (let i = startIndex, j = 0; i <= stopIndex; i += 1, j += 1) {
        if (items[j]) {
          itemStatusMap.set(i, items[j]);
        }
      }
    }

    let newItemStatusMap;

    if (items.length !== totalResults) {
      newItemStatusMap = itemStatusMap;
    } else {
      newItemStatusMap = new Map();

      items.forEach((item, i) => itemStatusMap.set(i, item));
    }

    this.setState({ itemStatusMap: newItemStatusMap });

    this.attemptToClearLoadingTimer();

    const { loading } = this.state;

    if (!loading) {return null;}

    this.setState({ loading: false });

    return null;
  };

  renderItemCheckbox = ({
    listItem,
    index
  }) => {
    const { listKey, bulkActions, canSelectItems } = this.props;
    const { selectedItems, hasBulkActions } = this.state;

    if ((!bulkActions || !bulkActions.length) && !canSelectItems) {return null;}

    if (bulkActions && bulkActions.length && !hasBulkActions) {
      const { permissions } = listItem;

      const allowedActions = bulkActions.filter(
        ({ requiredPermission }) => !requiredPermission ||
        Boolean(permissions && permissions.includes(requiredPermission))
      );

      if (!allowedActions.length && !canSelectItems) {return null;}

      this.setState({ hasBulkActions: true });
    }

    return (
      <Checkbox
        onChange={this.onSelectItem(index)}
        checked={Boolean(selectedItems[listItem[listKey]])} />);


  };

  isItemLoaded = (index) => {
    const { itemStatusMap } = this.state;

    return !!itemStatusMap.get(index);
  };

  getCell = (
  selectedItems,
  listKey,
  view,
  viewRenderFn,
  filteredData,
  columnCount,
  rowCount) =>
  ({ columnIndex, rowIndex, style



  }) => {
    const { itemStatusMap } = this.state;
    const index = rowIndex * columnCount + (rowIndex + 1 > rowCount ? 0 : columnIndex);
    const item = itemStatusMap.get(index);

    return this.getItem(
      item,
      style,
      selectedItems,
      listKey,
      filteredData,
      view,
      index,
      viewRenderFn
    );
  };

  getRow = (
  selectedItems,
  listKey,
  view,
  viewRenderFn,
  filteredData) =>
  ({ index, style }) => {
    const { itemStatusMap } = this.state;
    const item = itemStatusMap.get(index);

    return this.getItem(
      item,
      style,
      selectedItems,
      listKey,
      filteredData,
      view,
      index,
      viewRenderFn
    );
  };

  getItem = (
  item,
  style,
  selectedItems,
  listKey,
  filteredData,
  view,
  index,
  viewRenderFn) =>
  {
    const { canSelectItems, bulkActions, totalResults } = this.props;
    const { itemStatusMap, loading } = this.state;
    const customStyle = view === LIST_VIEW ? style : {
      ...style,
      left: style.left + GUTTER_SIZE,
      top: style.top + GUTTER_SIZE,
      width: style.width - GUTTER_SIZE,
      height: style.height - GUTTER_SIZE
    };

    if (item) {
      return (
        <div
          style={customStyle}
          className={cx(
            'react-window-list-container__content__item',
            { 'react-window-list-container__content__item--selected': selectedItems[item[listKey]] }
          )}
          key={item[listKey]}>

          {this.renderItemCheckbox({ view, listItem: item, index })}
          {viewRenderFn && viewRenderFn(item, index)}
        </div>);

    }

    const notAllItemsLoaded = filteredData.length === Array.from(itemStatusMap.values()).length &&
    Array.from(itemStatusMap.values()).length !== totalResults;

    if (notAllItemsLoaded || loading) {
      return (
        <div style={customStyle}>
          <Placeholder
            key={index}
            view={view}
            style={style}
            hasBulkActions={canSelectItems || Boolean(bulkActions)} />

        </div>);

    }

    return null;
  };

  // $FlowFixMe
  getInnerElementType = () => forwardRef(({ style, ...rest }, ref) =>
  <div
    ref={ref}
    style={{
      ...style,
      paddingTop: GUTTER_SIZE
    }}
    {...rest} />

  );

  // These are to provide the exports for List.ListItem & List.CardItem
  static ListItem = ListItem;

  static CardItem = CardItem;

  static CardCaption = CardCaption;

  render() {
    const {
      searchTerm,
      bothViewsAvailable,
      selectedFilters,
      selectedItems,
      hasBulkActions,
      itemStatusMap
    } = this.state;
    const {
      history,
      bulkActions,
      location,
      loading,
      filters,
      renderCardItem,
      renderListItem,
      listKey,
      children,
      filtersRightAddon,
      totalResults = 100,
      onFiltersChange,
      hideFilters,
      maxDisplayNum = 0,
      canSelectItems,
      customSearchText,
      maxItemHeight,
      maxItemWidth,
      bulkActionsSuffix
    } = this.props;
    const data = Array.from(itemStatusMap.values());
    const filteredData = this.getFilteredData(
      data,
      selectedFilters,
      searchTerm,
      onFiltersChange
    );
    const view = this.getView(location.hash);
    const viewRenderFn = view === LIST_VIEW ? renderListItem : renderCardItem;
    const selectedItemsData = data.filter((item) => selectedItems[item[listKey]]);
    const hasFilters = searchTerm || Object.keys(selectedFilters).length;

    return (
      <SizeMe monitorHeight>
        {({ size }) => {
          const windowSize = size.width && size.height ? size : { width: 1, height: 1 };
          const isMobile = windowSize.width < NUMERIC_MEDIA_SIZES.small;
          const filterPanelHeight = 110;

          const gridItemWidth = (maxItemWidth || GRID_ITEM_WIDTH) + GUTTER_SIZE;
          const calculatedWidth = windowSize.width / Math.ceil(windowSize.width / gridItemWidth);

          const columnCount = Math.floor(windowSize.width / calculatedWidth);
          const rowCount = Math.ceil(totalResults / columnCount);

          const columnWidth = gridItemWidth <= calculatedWidth ||
          totalResults <= Math.floor(windowSize.width / gridItemWidth) ?
          gridItemWidth :
          calculatedWidth;
          const rowHeight = maxItemHeight || GRID_ITEM_HEIGHT;

          const noData = filteredData.length === 0 && !loading && !hasFilters && !customSearchText;
          const noFilteredData = filteredData.length === 0 &&
          !loading && (
          hasFilters || customSearchText);

          return (
            <div className={cx('react-window-list-container', LIST_CONTAINER({ loading, isMobile }))}>
              {!hideFilters &&
              <Filters
                history={history}
                isMobile={isMobile}
                view={view}
                filters={filters}
                onChangeView={this.handleChangeView}
                setSelectedFilters={this.setSelectedFilters}
                resetFilters={this.resetFilters}
                selectedFilters={selectedFilters}
                onSearch={_debounce(this.onSearch, 250)}
                bothViewsAvailable={bothViewsAvailable}
                filtersRightAddon={filtersRightAddon}
                totalResults={totalResults}
                numberOfItems={filteredData.length}
                searchTerm={searchTerm}
                customSearchText={customSearchText} />}


              {
              (canSelectItems || hasBulkActions) && filteredData.length ?

              <BulkActions
                actions={bulkActions}
                onSelectAction={this.onSelectBulkAction}
                onSelectAll={this.onSelectItem()}
                totalItems={data.length}
                totalResults={totalResults}
                suffix={bulkActionsSuffix}
                selectedItems={Object.values(selectedItems).filter(Boolean).length}
                selectedItemsData={selectedItemsData} /> :


              null}

              {
              maxDisplayNum && filteredData.length > maxDisplayNum ?

              <div className="react-window-list__result-limit">
                      <Icon color="michael" name="alert" size={25} />
                      <p>
                        Too many results to display. Use the filters to find the items you need.
                      </p>
                    </div> :

              null}

              {
              !noData && !noFilteredData ?
              <InfiniteLoader
                isItemLoaded={this.isItemLoaded}
                itemCount={totalResults}
                loadMoreItems={this.loadMoreResults}>

                    {({ onItemsRendered, ref }) =>
                <div
                  className={cx(
                    'react-window-list-container__content',
                    {
                      'react-window-list-container__content--grid': view === GRID_VIEW
                    }
                  )}>

                        {
                  view === LIST_VIEW ?

                  <FixedSizeList
                    height={windowSize.height}
                    itemCount={totalResults}
                    itemSize={150}
                    onItemsRendered={onItemsRendered}
                    ref={ref}
                    width={windowSize.width + GUTTER_SIZE}>

                                {
                    this.getRow(
                      selectedItems,
                      listKey,
                      view,
                      viewRenderFn,
                      filteredData)}

                              </FixedSizeList> :


                  <FixedSizeGrid
                    className="react-window-list-container__content--items-grid"
                    columnCount={totalResults <= columnCount ?
                    totalResults :
                    columnCount}
                    columnWidth={columnWidth}
                    rowCount={rowCount}
                    rowHeight={rowHeight + GUTTER_SIZE}
                    height={windowSize.height - filterPanelHeight}
                    width={windowSize.width + GUTTER_SIZE}
                    innerElementType={this.getInnerElementType()}
                    onItemsRendered={(gridProps) => {
                      onItemsRendered({
                        overscanStartIndex: gridProps.overscanRowStartIndex *
                        columnCount,
                        overscanStopIndex: gridProps.overscanRowStopIndex *
                        columnCount,
                        visibleStartIndex: gridProps.visibleRowStartIndex *
                        columnCount,
                        visibleStopIndex: gridProps.visibleRowStopIndex *
                        columnCount
                      });
                    }}
                    ref={ref}>

                                {this.getCell(
                      selectedItems,
                      listKey,
                      view,
                      viewRenderFn,
                      filteredData,
                      columnCount,
                      rowCount
                    )}
                              </FixedSizeGrid>}


                      </div>}

                  </InfiniteLoader> :
              null}

              {children}
              {
              noFilteredData ?

              <EmptyDataPlaceholder
                customSearchText={customSearchText}
                searchTerm={searchTerm} /> :


              null}

              {
              filteredData.length === 0 && !loading && !hasFilters && !customSearchText ?

              <div className={cx('react-window-list__no-data-container', { 'react-window-list__no-data-container--mobile': isMobile })}>
                      <div className="react-window-list__no-data__svg-container">
                        <SVG cacheRequests src={empty} uniquifyIDs title="There's nothing here yet." />
                      </div>
                      <Text heading3 centered noMargin="top">{'There\'s nothing here yet, but we\'re excited you\'re here!'}</Text>
                    </div> :

              null}

            </div>);

        }}
      </SizeMe>);

  }
}